import React, { useEffect, useState } from "react";
import { Table, Grid, Checkbox as CheckBoxs, Button, Text, Modal, Row, Textarea, Loading } from "@nextui-org/react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Checkbox from './checkbox'
import { Input } from "rsuite";
import { message } from "antd";
import { decode } from "html-entities";
import { exhibitionlist } from "../../apis/urls";



const ExhibitionPendingList =()=> {

    const {id} = useParams();

    const [result, setResult] = useState([]);



  useEffect(()=>{
    paymentPendingStatus()
  },[])


  // TODO PAYMENT STATUS LISTING

  const paymentPendingStatus = () => {

    let token = "Bearer "+localStorage.getItem('token');

    const instance = axios.create({

        baseURL: `${exhibitionlist}/register/${id}?payment=PENDING&size=10000`,

        timeout: 1000000,

        headers: {'authorization': token}

      });
      
      instance.get('').then((response) =>{

        setResult(response?.data)

        console.log("")
        
      }).catch((error) =>{
        
    });

}


const [isCheck, setIsCheck] = useState([]);
const [isCheckAll, setIsCheckAll] = useState(false);
const [payDetails, setPayDetails] = useState('')

// TODO SELECT ALL

const handleSelectAll = (e) => {
  setIsCheckAll(!isCheckAll);
  setIsCheck(result?.data.map((li) => li.id));
  console.log("check all", isCheck)
  if (isCheckAll) {
    setIsCheck([]);
  }
};

// TODO INDIVIDUAL SELECT

const handleClick = (e) => {
  const { id, checked } = e.target;
  let selectId = parseInt(id)
  setIsCheck([...isCheck, selectId]);
  if (!checked) {
    setIsCheck(isCheck.filter((item) => item !== selectId));
  }
  if(result.length !== isCheck.length){
    setIsCheckAll(false)
  }

  console.log("result.length", isCheck)

};

// TODO GISA ADMIN PAYMENT PENDING APPROVE

const paymentStatusChange = () => {

  let token = "Bearer "+localStorage.getItem('token');

  const data = {
    id:isCheck,
    payment_details:payDetails
  }

  const instance = axios.create({

      baseURL: `${exhibitionlist}/register/approve/payment`,

      timeout: 1000000,

      headers: {'authorization': token}

    });
    
    instance.patch('', data).then((response) =>{

      closeHandler();

      paymentPendingStatus();

      // window.location.reload();


      message.success('Payment successfully completed');

      
    }).catch((error) =>{
      
    });

}

// TODO MODEL 


const [visible, setVisible] = React.useState(false);
const handler = () => setVisible(true);

const closeHandler = () => {
  setVisible(false);
  console.log("closed");
};



  return (
    <div className="wrapper">
      <aside class="right-side areas">
        <div class="content-area dash-contentss">


              <div class="page-title-wrpr">
                  <div class="page-title-left-column">
                      <h2 class="page-title">Check Payment Pending Officials List - {decode(result?.eName)}</h2>
                  </div>
              </div>


              <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                      <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                      <li className="breadcrumb-item active" aria-current="page"><Link to="/exhibition">Exhibition</Link></li>
                      <li className="breadcrumb-item active" aria-current="page"><Link to={"/exhibition_register/"+id}>Register List</Link></li>
                      <li className="breadcrumb-item active" aria-current="page">Payment pending</li>

                  </ol>
				      </nav>



        {result?.data?.length !== 0 &&
            <div> 
                <Grid.Container gap={2}>
                <Grid xs={12} >
                    <Table
                        aria-label="Example dynamic collection table with color selection"
                        color="error"
                        containerCss={{
                        height: "auto",
                        minWidth: "100%",
                        }}
                    >
                        
                    <Table.Header>
                        <Table.Column>
                        <CheckBoxs onChange={handleSelectAll} isSelected={isCheckAll} />
                        </Table.Column>
                        <Table.Column css={{color:'red'}}>NAME</Table.Column>
                        <Table.Column css={{color:'#fff'}}>EMAIL</Table.Column>
                        <Table.Column css={{color:'#fff'}}>PHONE</Table.Column>
                    </Table.Header>
                    

                    <Table.Body>
                        {result?.data?.items?.map((item, index, ids, name) => (
                            <Table.Row>
                                <Table.Cell>
                                <Checkbox
                                    classes="pending-table"
                                    key={ids}
                                    type="checkbox"
                                    name={name}
                                    id={item?.id}
                                    handleClicks={handleClick}
                                    isChecked={isCheck.includes(item?.id)}
                                    className="select-individual-check"
                                />              
                                </Table.Cell>
                                <Table.Cell>{item?.fname + ' ' + item?.lname}</Table.Cell>
                                <Table.Cell>{item?.email}</Table.Cell>
                                <Table.Cell>{item?.phone}</Table.Cell>

                            </Table.Row>
                        ))}
                    </Table.Body>

                    </Table>
                </Grid>
                </Grid.Container>

                <Grid.Container gap={2}>
                <Grid xs={12} style={{justifyContent:'flex-end'}}>
                    <Button style={{width:'15%', borderRadius:'5px', padding:'20px'}} onClick={handler} shadow color="primary" auto>
                    <Text style={{fontSize:'15px', color:'#fff', fontWeight:'900'}}>Approve Payment</Text>
                    </Button>
                </Grid>
                </Grid.Container>



                <Modal
                closeButton
                aria-labelledby="modal-title"
                open={visible}
                onClose={closeHandler}
                >
                <Modal.Header>
                    <Text h1 size={30} 
                    css={{textGradient: "45deg, $yellow600 -20%, $red600 100%"}} weight="bold">
                        Confirmation
                    </Text>
                </Modal.Header>
                <Modal.Body>
                    <Row justify="space-between">
                    <Input onChange={(value)=>setPayDetails(value)} className="text-area-pending" as="textarea" rows={3} placeholder="Enter Something" />
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Grid.Container>
                    <Grid xs={6} style={{justifyContent:'flex-start'}}>
                        <Button auto flat color="error" onClick={closeHandler} style={{width:'60%', borderRadius:'5px', padding:'18px'}}>
                        <Text style={{fontSize:'12px',color:'crimson', fontWeight:'900'}}>Close</Text>
                        </Button>
                    </Grid>
                    <Grid xs={6} style={{justifyContent:'flex-end'}}>
                        <Button auto onClick={paymentStatusChange} style={{width:'60%', borderRadius:'5px', padding:'18px'}}>
                        <Text style={{fontSize:'12px',color:'#fff', fontWeight:'900'}}>Confirm</Text>
                        </Button>
                    </Grid>
                    </Grid.Container>
                </Modal.Footer>
                </Modal>
            </div>
        }
        {result?.data?.length === 0 && 
            <Grid.Container style={{marginTop:'10%'}}>
              <Grid xs={12} style={{justifyContent:'center'}}>
                <Text h1>Sorry! No Result Found</Text>
              </Grid>
            </Grid.Container>
        }

          </div>
        </aside>
    </div>
  );
}

export default ExhibitionPendingList